import React from "react";
import {LeagueInviteForm} from "components/Leagues/Invites";
import {useDigitParams} from "modules/utils";
import styled from "@emotion/styled";

const Container = styled.section`
	//max-width: 300px;
	padding: 16px 20px;
	gap: 16px;
	background: #292f37;
	border-radius: 8px;
	margin-top: 16px;
	width: 100%;
	flex-shrink: 0;

	button {
		max-width: 180px;
	}

	@media (max-width: 880px) {
		max-width: 100%;
		background: transparent;
		button {
			max-width: 100%;
		}
	}
`;

const Title = styled.div`
	font-weight: 700;
	font-size: 20px;
	line-height: 120%;
`;
const GroupInvites: React.FC = () => {
	const {id} = useDigitParams("id");

	return (
		<Container>
			<Title>Invite Your Friends</Title>
			<LeagueInviteForm leagueId={id} />
		</Container>
	);
};

export default GroupInvites;
